import { connect } from 'react-redux';
import noop from 'lodash/noop';

import { error as showNotificationError } from 'zoomforth_app_basics/action_creators/notifications.js';
import ReplaceAssetModal from './replace_asset_modal.jsx';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => (
  {
    onShowReplaceErrorNotification: (message='An error occured while uploading the selected file, please try again later. If the problem persists please contact support.')=> { 
      dispatch(showNotificationError({ children: message })); 
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReplaceAssetModal);
